import { useSelector } from "react-redux";
import * as  R from 'ramda';
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectOrdersCreatedItem } from "../../../../../redux/orders/selector";
import { selectVariantsListItems } from "../../../../../redux/variants/selector";
import { variants } from "../../../../../redux/variants/action";
import { currency } from "../../../../../common/services/common.service";
import { quotes } from "../../../../../redux/quotes/action";
import { leads } from "../../../../../redux/leads/action";

const IndexOrderDetailMobile = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const orderDetails = useSelector(selectOrdersCreatedItem)
  const variantLists = useSelector(selectVariantsListItems)

  const back = () => {
    dispatch(quotes.resetAction({ actionType: 'create' }))
    dispatch(leads.resetAction({ actionType: 'create' }))
    localStorage.removeItem('access-token')
    localStorage.removeItem('accessTokenMetadata')
    localStorage.removeItem('userProfile')
    navigate('/')
  }
  const handleLogin = () => {
    localStorage.removeItem('access-token')
    localStorage.removeItem('accessTokenMetadata')
    localStorage.removeItem('userProfile')
    navigate('/auth/login/customer')
  }
  const getProductName = (LogisticsVariantId: any) => {
    const Variant = R.find(
      (variant: any) => parseInt(
        variant.Id,
        10
      ) === parseInt(
        LogisticsVariantId,
        10
      ),
      variantLists?.result?.items
    )
    return Variant ? Variant.Name : ''
  }
  const orderData = orderDetails?.result?.items?.Records[0]?.message?.order
  useEffect(
    () => {
      dispatch(variants.list({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/variants/list`, entity: 'variants', jsonData: {}
      }))

    },
    []
  );
  return (

    <div className='py-28 px-4'>
      {/* Order Details Heading and Buttons */}
      <div className="flex justify-between items-center mb-6">
        <div className="uppercase font-bold text-lg">Order details:</div>
        <div className="flex space-x-2">
          <button
            onClick={back}
            type="button"
            className="bg-blue-700 text-white rounded font-medium px-4 py-2 text-sm"
          >
            Back To Booking
          </button>
          <div className="flex flex-col justify-center items-center space-y-1">
            <span className="text-sm text-black text-opacity-50">More details?</span>
            <span
              onClick={handleLogin}
              className="text-primary text-opacity-100 cursor-pointer text-sm"
            >
              Login
            </span>
          </div>
        </div>
      </div>

      {/* Order Items Table */}
      <table className="w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase">Category</th>
            <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase">Product</th>
            <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase">Quantity</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {orderData?.['@ondc/org/linked_order']?.items?.map((cardData: any, index: any) => (
            <tr key={index} className={`${index % 2 === 0 ? 'bg-gray-100' : 'bg-white'}`}>
              <td className="p-2">{cardData?.CategoryName}</td>
              <td className="p-2">{getProductName(cardData?.LogisticsVariantId)}</td>
              <td className="p-2">{cardData.quantity.count}</td>
            </tr>
          ))}
          <tr className="bg-gray-400">
            <td className="p-2">
              Total Items: {orderData?.['@ondc/org/linked_order']?.items?.length}
            </td>
            <td colSpan={2} className="p-2">
              Total Price: {currency(orderData?.quote?.price?.value)}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Address Details */}
      <div className="space-y-4">
        {/* Billing Address */}
        <div className="bg-gray-50 p-4 border rounded">
          <div className="text-lg border-b text-cyan-600 font-bold">Billing Address</div>
          <div className="text-sm pt-2 space-y-1">
            <p>{orderData?.billing?.name},</p>
            <p>{orderData?.billing?.address?.locality},</p>
            <p>
              {orderData?.billing?.address?.city} - {orderData?.billing?.address?.area_code},
            </p>
            <p>{orderData?.billing?.address?.state},</p>
            <p>{orderData?.billing?.address?.country},</p>
            <p>Email: {orderData?.billing?.email},</p>
            <p>Ph: {orderData?.billing?.phone}.</p>
          </div>
        </div>

        {/* From Address */}
        <div className="bg-gray-50 p-4 border rounded">
          <div className="text-lg border-b text-cyan-600 font-bold">From Address</div>
          <div className="text-sm pt-2 space-y-1">
            <p>{orderData?.fulfillments[0]?.start?.location?.address?.locality},</p>
            <p>
              {orderData?.fulfillments[0]?.start?.location?.address?.city} -{' '}
              {orderData?.fulfillments[0]?.start?.location?.address?.area_code},
            </p>
            <p>{orderData?.fulfillments[0]?.start?.location?.address?.state},</p>
            <p>{orderData?.fulfillments[0]?.start?.location?.address?.country},</p>
            <p>Email: {orderData?.fulfillments[0]?.start?.contact?.email},</p>
            <p>Ph: {orderData?.fulfillments[0]?.start?.contact?.phone}.</p>
          </div>
        </div>

        {/* To Address */}
        <div className="bg-gray-50 p-4 border rounded">
          <div className="text-lg border-b text-cyan-600 font-bold">To Address</div>
          <div className="text-sm pt-2 space-y-1">
            <p>{orderData?.fulfillments[0]?.end?.location?.address?.locality},</p>
            <p>
              {orderData?.fulfillments[0]?.end?.location?.address?.city} -{' '}
              {orderData?.fulfillments[0]?.end?.location?.address?.area_code},
            </p>
            <p>{orderData?.fulfillments[0]?.end?.location?.address?.state},</p>
            <p>{orderData?.fulfillments[0]?.end?.location?.address?.country},</p>
            <p>Email: {orderData?.fulfillments[0]?.end?.contact?.email},</p>
            <p>Ph: {orderData?.fulfillments[0]?.end?.contact?.phone}.</p>
          </div>
        </div>
      </div>


    </div>



  );
};

export default IndexOrderDetailMobile;


